// var apiEndPoint = "https://services.yankeekicks.com/userauth_dev/";
var apiEndPoint = "https://api.yankeekicks.com/v1/userauth/";
var codeLists = [];
var dataTable = initializeDataTable();
loadCodeListHistory(dataTable);

// Function to load data into DataTable
function loadCodeListHistory(dataTable) {
    $.get(apiEndPoint + "buyerLoyalty/discount-history/"+email, function(data) {
        $.each(data, function(index, item) {
            var row = [
                item.discountCode +`<span class="copy-container"><img style="cursor:pointer" src="https://cdn.shopify.com/s/files/1/0702/0052/5105/t/6/assets/CopySimple.png?v=1706887718" onclick="copyOrderNumberToClipBoard('${item.discountCode}', this)"><span class="copy-tooltip">Copied!</span></span>`,
                item.location,
                item.points,
                item.status == 'Active' ? "<span class='green'>Active</span>" : "<span class='expired'>Expired</span>",
                formatIngDate(item.endsAt)
            ];
            // Add the row to DataTable
            dataTable.row.add(row).draw();
        });
    });
}

function formatIngDate(dateString) {
    const options = {year:"numeric", month:"short", day:"numeric"}
    //const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
}

function initializeDataTable() {
  return $('#data-table').DataTable({
        searching: true,
        paging: false,
        lengthMenu: [5, 10, 25, 50],
        pageLength: 10,
        lengthChange: false,
        pagingType:"simple_numbers",
        language: {
          searchPlaceholder: "Search Codes",
          search: ""
        },
    columnDefs: [
            { type: 'date', targets: 4 } // Specify the type of the fifth column (date)
        ],
     order: [[4, 'desc']] // Automatically sort the fifth column (date column) in descending order
    });
}

function copyOrderNumberToClipBoard(params, element) {
    navigator.clipboard.writeText(params)
        .then(() => showCopyTooltip(element))
        .catch(err => console.error('Unable to copy to clipboard', err));
}

function showCopyTooltip(element) {
    var tooltip = element.nextElementSibling;
    tooltip.style.visibility = 'visible';
    setTimeout(function() {
        tooltip.style.visibility = 'hidden';
    }, 1000); // Hide the tooltip after 1 second
}
